import { BaseState } from "./BaseState";
import { StateManager } from "../GameStateManager";
import { AnimatorManager } from "../AnimatorManager";
import { AnimatorManagerEvents } from "../Consts";
import { GameObject } from "@needle-tools/engine";

class PreRaceState extends BaseState<StateManager> {
  public id = "PreRaceState"; // A unique identifier for the state
  constructor(stateManager: StateManager) {
    super(stateManager); // Pass the StateManager to the base class
    this.bindEvents();
  }

  public onEnter(stateManager: StateManager): void {
    this.stateManager = stateManager;
    super.onEnter(stateManager); // Call the super method
    this.stateManager.enteredPreRaceState();
    this.subscribeToEvents(); //Here and not in constructor as it doesnt always get a reference to the animator otherwise
  }

  public onExit(): void {
    super.onExit();
  }

  private bindEvents() {
    this.transition = this.transition.bind(this);
  }

  private subscribeToEvents() {
    const animatorManager = GameObject.findObjectOfType(AnimatorManager);
    if (animatorManager === null) {
      console.log("PreRaceState: AnimatorManager not found!");
      //keep trying until we get a reference to the animator
      if (animatorManager === null) {
        setTimeout(() => {
          this.subscribeToEvents();
        }, 1000);
        return;
      }
    } else {
      console.log("PreRaceState: AnimatorManager WAS found!");
      animatorManager?.unsubscribeFromEvent(
        AnimatorManagerEvents.ON_ANIMATION_DOWNLOADED,
        this.transition,
      );
      animatorManager?.subscribeToEvent(
        AnimatorManagerEvents.ON_ANIMATION_DOWNLOADED,
        this.transition,
      );

      animatorManager.load();
    }
  }

  public transition(): void {
    console.log("Transitioning to RaceInProgressState from PreRaceState");
    this.stateManager?.changeState(this.stateManager.raceInProgressState);
  }
}

export { PreRaceState };
